import React, { Component } from "react";
import { observer } from "mobx-react";
import "./index.css";
import Tab from "../tap";
import Title from "../GoBackShop";
import home from "../../store/index.js";
import { withRouter } from "react-router-dom";
import Bridge from "../../static/js/Bridge";
import xss from "xss";

@observer
class GuideDetail extends Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    const detailEle = document.querySelector('.guide .detail')
    detailEle.addEventListener("click", (e) => {
      if (e.target.tagName === "VIDEO") {
        this.imgClick(e.target.src);
      }
    });
    //   详情content是富文本 需要处理
    home.getGuideDetail({
      data: {
        id: this.props.match.params.id,
      },
      cb: () => {
        this.setVideo();
      },
    });
  }
  showPic(url) {
    Bridge.jumpPhotosBrowser({ url: url });
  }
  imgClick(url) {
    if (Bridge.isAndroid) {
      console.log('android')
      Bridge.jumpPhotosBrowser({ url: url, type: "video" });
    } else {
      console.log('ios')
      // this.videoPlay(url)
    }
  }
  setVideo() {
    //将带有视频链接的img标签 转换为video标签
    let imgToVideo = document.getElementsByTagName("img");
    let len = imgToVideo.length;
    try {
      for (let inds = 0; inds < len; inds++) {
        if (imgToVideo[inds].id.includes("mp4")) {
          let embedHtml
          if (Bridge.isAndroid) {
            embedHtml = `<video style="width: 95%; height: 95%;"  src="${imgToVideo[inds].id}"  poster="${imgToVideo[inds].src}" width="300" height="150"></video><span class="icon"></span>`;
          } else {
            embedHtml = `<video style="width: 95%; height: 95%;"  src="${imgToVideo[inds].id}" controls  poster="${imgToVideo[inds].src}" width="300" height="150"></video>`;
          }
          imgToVideo[inds].outerHTML = embedHtml;
          inds = 0;
        }
      }
    } catch (error) { }
  }
  handelData(data) {
    if (data) {
      return xss(
        data
          .toString()
          .replaceAll("&quot;", '"')
          .replaceAll("&amp;", "&")
          .replaceAll("&lt;", "<")
          .replaceAll("&gt;", ">"),
        {
          whiteList: {
            p: ["style"],
            img: ["src", "id", "style", "height", "width"],
            a: ["href"],
            em: ["style"],
            span: ["style"],
            strong: ["style"],
            ol: ["style"],
            ul: ["style"],
            li: ["style"],
          },
          onTagAttr: (tag, name, value, isWhiteAttr) => {
            if (name === "href" && value.includes("javascript:")) {
              return value.replace("javascript:", "");
            }
          },
        }
      );
    }
  }
  render() {
    return (
      <div className="guide">
        <Title />
        <div className="detail">
          <span>{home.guideDetailData.title}</span>
          <span>{home.guideDetailData.createTime}</span>
          <span>{home.guideDetailData.author}</span>
          <a href={home.guideDetailData.url}>{home.guideDetailData.url}</a>
          <div
            id="content"
            dangerouslySetInnerHTML={{
              __html: this.handelData(home.guideDetailData.content),
            }}
          ></div>
        </div>
        <Tab />
      </div>
    );
  }
}
export default withRouter(GuideDetail);
